export const Name = 'invite-confirmation-modal-test';
